import React, { ReactNode, useState } from "react";
import { ThemeContext, themeContextDefaults } from "../context/themeContext";
import { ThemeProps } from "../models/theme";

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<ThemeProps>(themeContextDefaults.theme);

  const clearData = () => {
    setTheme(themeContextDefaults.theme);
  };

  /* eslint-disable */
  const updateTheme = (data: any) => {
    const value = { ...theme, ...data };
    setTheme(value);
  };

  const value = React.useMemo(
    () => ({
      theme,
      clearData,
      updateTheme,
    }),
    [theme]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
